import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import { resolveImageUrl } from '@ai-tiaozs/shared';

export function SafeImage({
  team,
  imageUrl,
  imageKey,
  alt,
  className = 'h-14 w-14 rounded-md object-cover ring-1 ring-slate-200',
  placeholderClassName = 'flex h-14 w-14 items-center justify-center rounded-md bg-teamB-light/30 text-slate-400',
}: {
  team: 'a' | 'b';
  imageUrl?: string | null;
  imageKey?: string | null;
  alt: string;
  className?: string;
  placeholderClassName?: string;
}) {
  const [errored, setErrored] = useState(false);
  const url = resolveImageUrl({ imageUrl, imageKey, team });
  if (!url || errored) {
    return (
      <div className={placeholderClassName} aria-label="暂无照片">
        <ImageOff className="h-4 w-4" />
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} onError={() => setErrored(true)} />;
}
